import { LocalStorage } from 'utils/config'
import { THIRD_ACCESS_TOKEN, EDMODO_USER_INFO } from 'utils/constants'
import { sGetEdmodoUser } from 'apis/edmodo'
// import { Store } from 'vuex'
export default async function edmodoUser (token) {
  const edmodo_user_info = LocalStorage.get(EDMODO_USER_INFO)
  if (edmodo_user_info) {
    return edmodo_user_info
  } else {
    const __third_access_token = token || LocalStorage.get(THIRD_ACCESS_TOKEN)
    if (__third_access_token) {
      return await sGetEdmodoUser(__third_access_token).then(res => {
        const { data } = res
        if (data) {
          LocalStorage.set(EDMODO_USER_INFO, data)
        }
        return data
      })
    } else {
      return { type: 'unknown' }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/edmodoUser.js